import { Components, Theme } from '@mui/material/styles';

export const muiCheckboxOverride: Components<Omit<Theme, 'components'>>['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true
  },
  styleOverrides: {
    root: {
      fontSize: '0.875rem',
      '&.Mui-focusVisible': {
        outline: '2px solid #000',
        outlineOffset: '2px'
      }
    }
  }
};
